import { mapGetters, mapMutations } from "vuex";
import alertHelper from "@/helper/AlertHelper";

export const paymentMixin = {
  data() {
    return {
      whichGateAway: [],
      noGateWayActive: false,
      apiPending: true,
    };
  },
  computed: {
    ...mapGetters([
      "getIsCompName",
      "getVersion",
      "getGlobalApiRequestPending",
      "getMobileNumber",
      "getCompleteCreditCardNumber",
      "getGatewayPendingFlag",
      "getSitesApiResult",
      "getMobileLayout",
      "getStepperPage",
    ]),
    mobileSize() {
      return this.getMobileLayout;
    },
    isCryptoGroupActive() {
      return ["tether", "tron", "cryptoGroup", "bitcoin"].includes(
        this.getIsCompName
      );
    },
  },
  methods: {
    ...mapMutations([
      "setCreditCardReceivedFromServerCondition",
      "setPhoneNumberReceivedFromServerCondition",
      "setShetabAmountsReceivedFromServerCondition",
      "setGlobalApiRequestPending",
      "setTetherCurrentPrice",
      "setVatanCurrentPrice",
      "setBitcoinCurrentPrice",
      "setPerfectMoneyCurrentPrice",
      "setTronCurrentPrice",
      "setShaparakAmounts",
      "setGatewayPendingFlag",
      "setCompleteCreditCardNumber",
      "setPayingAmount",
      "setMobileNumber",
      "setSiteId",
      "setCallBackUrl",
      "setCryptoGroupActiveGateways",
      "setAppLang",
    ]),
    goTo(link) {
      const queryId = this.$route.query.id;
      const querySecret = this.$route.query.s;
      // If the Shetab GateAway was Enable
      if (link === "/" && this.whichGateAway.includes("shetab"))
        this.$router.push(`${link}?id=${queryId}&s=${querySecret}`);
      // If the Tether GateAway was Enable
      else if (link === "/tether" && this.whichGateAway.includes("tether"))
        this.$router.push(`${link}?id=${queryId}&s=${querySecret}`);
      // If the Bitcoin GateAway was Enable
      // else if (link === "/bitcoin" && this.whichGateAway.includes("bitcoin"))
      //   this.$router.push(`${link}?id=${queryId}&s=${querySecret}`);
      // If the Perfect Money GateAway was Enable
      else if (
        link === "/perfect-money" &&
        this.whichGateAway.includes("perfect-money")
      )
        this.$router.push(`${link}?id=${queryId}&s=${querySecret}`);
      else if (link === "/vouchers" && this.whichGateAway.includes("vouchers"))
        this.$router.push(`${link}?id=${queryId}&s=${querySecret}`);
      else if (link === "/shaparak" && this.whichGateAway.includes("shaparak"))
        this.$router.push(`${link}?id=${queryId}&s=${querySecret}`);
      else if (link === "/ctc")
        this.$router.push(`${link}?id=${queryId}&s=${querySecret}`);
      else if (link === "/ata")
        this.$router.push(`${link}?id=${queryId}&s=${querySecret}`);
      else if (link === "/tron")
        this.$router.push(`${link}?id=${queryId}&s=${querySecret}`);
      else if (link === "/indirect") {
        this.$router.push(`${link}?id=${queryId}&s=${querySecret}`);
      } else if (
        link === "/crypto-group" &&
        (this.whichGateAway.includes("tether") ||
          this.whichGateAway.includes("tron") ||
          this.whichGateAway.includes("tether-erc20") ||
          this.whichGateAway.includes("vatan-erc20") ||
          this.whichGateAway.includes("bitcoin") ||
          this.whichGateAway.includes("tether-bep20"))
      ) {
        let activeCrypto = [
          "tether",
          "tron",
          "tether-bep20",
          "tether-erc20",
          "vatan-erc20",
          "bitcoin",
        ].filter((crypto) => this.whichGateAway.includes(crypto));
        this.setCryptoGroupActiveGateways(activeCrypto);
        this.$router.push(`${link}?id=${queryId}&s=${querySecret}`);
      }
    },

    // Check What is the Payment Method
    checkWhichGateAway() {
      const queryId = this.$route.query.id;
      const querySecret = this.$route.query.s;
      const settingData = this.getSitesApiResult?.data?.settings;
      this.setGatewayPendingFlag(true);
      if (!queryId) {
        return;
      }
      //for example siteId === 2 (prado),
      // we have to not show tether, perfect and tron prices
      //if the previous info api had info, just set the tether and perfect money prices
      const previousSetGateway = this.whichGateAway[0]; // we know that previous api only sets one gateway
      if (previousSetGateway === "tether") {
        // if it was only one gateway we have to set the crypto prices right away
        this.setTronCurrentPrice(settingData.price_tron ?? "");
        this.setTetherCurrentPrice(settingData.price_tether ?? "");
        this.setVatanCurrentPrice(settingData.price_vatan ?? "");
        //  because we don't need other info from this api
        this.setGatewayPendingFlag(false);
        return;
      } else if (previousSetGateway === "tether-bep20") {
        this.setTetherCurrentPrice(settingData.price_tether);
        //  because we don't need other info from this api
        this.setGatewayPendingFlag(false);
        return;
      } else if (previousSetGateway === "vatan-erc20") {
        this.setVatanCurrentPrice(settingData.price_vatan);
        //  because we don't need other info from this api
        this.setGatewayPendingFlag(false);
        return;
      } else if (previousSetGateway === "bitcoin") {
        this.setBitcoinCurrentPrice(settingData.price_btc ?? "");
        //  because we don't need other info from this api
        this.setGatewayPendingFlag(false);
        return;
      } else if (previousSetGateway === "tether-erc20") {
        this.setTetherCurrentPrice(settingData.price_tether);
        //  because we don't need other info from this api
        this.setGatewayPendingFlag(false);
        return;
      } else if (previousSetGateway === "perfect-money") {
        this.setPerfectMoneyCurrentPrice(settingData.price_perfect_money);
        //  because we don't need other info from this api
        this.setGatewayPendingFlag(false);
        return;
      } else if (previousSetGateway === "vouchers") {
        this.setPerfectMoneyCurrentPrice(settingData.price_perfect_money);
        //  because we don't need other info from this api
        this.setGatewayPendingFlag(false);
        return;
      } else if (previousSetGateway === "tron") {
        this.setTronCurrentPrice(settingData.price_tron);
        this.setGatewayPendingFlag(false);
        return;
      } else if (previousSetGateway === "shaparak") {
        this.setShaparakAmounts(settingData.shaparak_amounts);
        this.setGatewayPendingFlag(false);
        return;
      } else if (previousSetGateway) {
        //previous api has set other gateways
        this.setGatewayPendingFlag(false);
        return;
      }

      if (settingData.shetab_gateway_enable) {
        this.whichGateAway.push("shetab");
      } else {
        // Because The Main Page (Root) Is Shetab, We Need to Check if the Shetab Gateway was disabled, then the router must change.
        if (settingData.tether_gateway_enable) {
          const gateways = ["tether", "tron"];
          if (settingData.tetherbep20_gateway_enable) {
            gateways.push("tether-bep20");
          }
          if (settingData.tethererc20_gateway_enable) {
            gateways.push("tether-erc20");
          }
          if (settingData.vatan_gateway_enable) {
            gateways.push("vatan-erc20");
          }
          if (settingData.bitcoin_gateway_enable) {
            gateways.push("bitcoin");
          }
          this.setCryptoGroupActiveGateways(gateways);
          this.$router.replace(`crypto-group?id=${queryId}&s=${querySecret}`);
        } else if (settingData.tetherbep20_gateway_enable) {
          this.setCryptoGroupActiveGateways(["tether-bep20"]);
          this.$router.replace(`crypto-group?id=${queryId}&s=${querySecret}`);
        } else if (settingData.tethererc20_gateway_enable) {
          this.setCryptoGroupActiveGateways(["tether-erc20"]);
          this.$router.replace(`crypto-group?id=${queryId}&s=${querySecret}`);
        } else if (settingData.vatan_gateway_enable) {
          this.setCryptoGroupActiveGateways(["vatan-erc20"]);
          this.$router.replace(`crypto-group?id=${queryId}&s=${querySecret}`);
        } else if (settingData.bitcoin_gateway_enable) {
          this.setCryptoGroupActiveGateways(["bitcoin"]);
          this.$router.replace(`crypto-group?id=${queryId}&s=${querySecret}`);
        } else if (settingData.perfect_money_gateway_enable)
          this.$router.replace(`perfect-money?id=${queryId}&s=${querySecret}`);
        else if (settingData.vouchers_gateway_enable)
          this.$router.replace(`vouchers?id=${queryId}&s=${querySecret}`);
        else if (settingData.shetab_offline_gateway_enable)
          this.$router.replace(`indirect?id=${queryId}&s=${querySecret}`);
        else if (settingData.shaparak_gateway_enable)
          this.$router.replace(`shaparak?id=${queryId}&s=${querySecret}`);
      }

      if (settingData.tether_gateway_enable) {
        this.whichGateAway.push("tether");
        this.whichGateAway.push("tron");
        this.setTronCurrentPrice(settingData.price_tron);
        this.setTetherCurrentPrice(settingData.price_tether);
      }
      if (settingData.tetherbep20_gateway_enable) {
        this.whichGateAway.push("tether-bep20");
        this.setTetherCurrentPrice(settingData.price_tether);
      }
      if (settingData.tethererc20_gateway_enable) {
        this.whichGateAway.push("tether-erc20");
        this.setTetherCurrentPrice(settingData.price_tether);
      }
      if (settingData.vatan_gateway_enable) {
        this.whichGateAway.push("vatan-erc20");
        this.setVatanCurrentPrice(settingData.price_vatan);
      }
      if (settingData.bitcoin_gateway_enable) {
        this.whichGateAway.push("bitcoin");
        this.setBitcoinCurrentPrice(settingData.price_btc ?? "");
      }
      // if the perfect money gateway added
      if (settingData.perfect_money_gateway_enable) {
        this.whichGateAway.push("perfect-money");
        // this.whichGateAway.push("cardToCard");
        this.setPerfectMoneyCurrentPrice(settingData.price_perfect_money);
      }
      if (settingData.vouchers_gateway_enable) {
        this.whichGateAway.push("vouchers");
        // this.whichGateAway.push("cardToCard");
        this.setPerfectMoneyCurrentPrice(settingData.price_perfect_money);
      }
      if (settingData.shetab_offline_gateway_enable) {
        this.whichGateAway.push("cardToCard");
        this.whichGateAway.push("accountToAccount");
      }
      // if (settingData.tron_gateway_enable) {
      //   this.whichGateAway.push("tron");
      //   this.setTronCurrentPrice(settingData.price_tron);
      // }
      if (settingData.shaparak_gateway_enable) {
        this.whichGateAway.push("shaparak");
        this.setShaparakAmounts(settingData.shaparak_amounts);
      }
      if (this.whichGateAway.length === 0) {
        this.noGateWayActive = true;
        alertHelper.fatalErrorAlert("", "درگاه پرداخت فعال وجود ندارد");
        this.setGatewayPendingFlag(false);
      } else {
        this.noGateWayActive = false;
        this.setGatewayPendingFlag(false);
      }
    },
    // Notice When A Tab is Disabled
    showDisabled() {
      alertHelper.infoAlert(
        "",
        "درگاه درخواستی برای این تراکنش غیر فعال است",
        "top-end"
      );
    },
    checkInfoStatusGateway(data, apiResult = {}) {
      const queryId = this.$route.query.id;
      const querySecret = this.$route.query.s;

      if (data.from) {
        this.setCompleteCreditCardNumber(data.from);
        this.setCreditCardReceivedFromServerCondition(true);
      }
      if (data.amount) {
        this.$nextTick(() => {
          this.setPayingAmount(data.amount?.toString());
        });
        this.$nextTick(() => {
          this.setShetabAmountsReceivedFromServerCondition(true);
        });
      }
      if (data.mobile) {
        this.setMobileNumber(data.mobile);
        this.setPhoneNumberReceivedFromServerCondition(true);
      }

      let inputGateway = data?.gateway;
      if (inputGateway === "SMART") {
        inputGateway = apiResult?.forced_gateway;
      }
      const settingData = this.getSitesApiResult?.data?.settings;
      let activeCryptoGateways = [];
      switch (inputGateway) {
        case "SHETAB":
          this.whichGateAway.push("shetab");
          if (window.location.pathname !== "/")
            //preventing duplicate error (only if the page was not in the root)
            //Note: replace instead of router push, because we don't want the location history, preveneting back button click routing to shetab (when it's unavailable)
            this.$router.replace(`/?id=${queryId}&s=${querySecret}`);
          break;
        case "SHETAB_OFFLINE":
          this.whichGateAway.push("cardToCard");
          this.whichGateAway.push("accountToAccount");
          if (window.location.pathname !== "/indirect")
            //preventing duplicate error (only if the page was not in the ctc)
            this.$router.replace(`indirect?id=${queryId}&s=${querySecret}`);
          break;
        case "PERFECT_MONEY":
          this.whichGateAway.push("perfect-money");
          if (window.location.pathname !== "/perfect-money")
            //preventing duplicate error (only if the page was not in the perfect money)
            this.$router.replace(
              `perfect-money?id=${queryId}&s=${querySecret}`
            );
          break;
        case "VOUCHERS":
          this.whichGateAway.push("vouchers");
          if (window.location.pathname !== "/vouchers")
            //preventing duplicate error (only if the page was not in the perfect money)
            this.$router.replace(`vouchers?id=${queryId}&s=${querySecret}`);
          break;
        case "BITCOIN":
          this.whichGateAway.push("bitcoin");
          if (window.location.pathname !== "/crypto-group")
            //preventing duplicate error (only if the page was not in the tether)
            this.$router.replace(`crypto-group?id=${queryId}&s=${querySecret}`);
          break;
        case "SHAPARAK":
          this.whichGateAway.push("shaparak");
          if (window.location.pathname !== "/shaparak")
            //preventing duplicate error (only if the page was not in the shaparak)
            this.$router.replace(`shaparak?id=${queryId}&s=${querySecret}`);
          break;
        case "TETHER":
          this.whichGateAway.push("tether");
          // also add tron
          this.whichGateAway.push("tron");

          activeCryptoGateways = ["tether", "tron"];
          // this.setCryptoGroupActiveGateways(activeCryptoGateways);
          if (settingData.tetherbep20_gateway_enable) {
            this.whichGateAway.push("tether-bep20");
            activeCryptoGateways.push("tether-bep20");
            //   this.setCryptoGroupActiveGateways([
            //     "tether",
            //     "tron",
            //     "tether-bep20",
            //   ]);
          }
          if (settingData.tethererc20_gateway_enable) {
            this.whichGateAway.push("tether-erc20");
            activeCryptoGateways.push("tether-erc20");
          }

          if (settingData.vatan_gateway_enable) {
            this.whichGateAway.push("vatan-erc20");
            activeCryptoGateways.push("vatan-erc20");
          }
          this.setCryptoGroupActiveGateways(activeCryptoGateways);

          if (window.location.pathname !== "/crypto-group")
            //preventing duplicate error (only if the page was not in the tether)
            this.$router.replace(`crypto-group?id=${queryId}&s=${querySecret}`);
          break;
        case "TRON":
          this.whichGateAway.push("tron");
          if (window.location.pathname !== "/crypto-group")
            //preventing duplicate error (only if the page was not in the tether)
            this.$router.replace(`crypto-group?id=${queryId}&s=${querySecret}`);
          break;
        default:
          break;
      }
    },
    getPaymentInfoStatus() {
      const queryId = this.$route.query.id;
      //because it may cause some problems if queryId is used in this condition
      if (queryId) {
        this.setGlobalApiRequestPending(true);
        this.$http.get(`payments/${queryId}`).then(
          (result) => {
            const inputData = result.body.data.inputs;
            //  checking gateway
            //more important info

            if (inputData) {
              this.setAppLang(inputData.lang);
              this.checkInfoStatusGateway(inputData, result.body.data);
            }
            this.checkWhichGateAway();
            this.$nextTick(() => {
              this.setGlobalApiRequestPending(false);
            });
            this.setCallBackUrl(result.body.data.callback_url || "");
            //second api
          },
          (error) => {
            this.checkWhichGateAway();
            this.setGlobalApiRequestPending(false);
            console.log(error);
          }
        );
      }
    },
    setDefaultValuesForStore() {
      this.setPhoneNumberReceivedFromServerCondition(false);
      this.setShetabAmountsReceivedFromServerCondition(false);
      this.setCreditCardReceivedFromServerCondition(false);
    },
  },
  created() {
    const paymentId = this.$route.query.id;
    if (!paymentId) alertHelper.transactionNotValidAlert();
    this.setDefaultValuesForStore();
    this.getPaymentInfoStatus();

    if (this.getVersion === "v2") {
      this.$router.replace(`/tether?id=${paymentId}`);
    }
  },
};
